/**
 * plugins/index.js
 *
 * Automatically included in `./src/main.js`
 */

// Plugins
import vuetify from './vuetify'
import i18n from './i18n'
import { VueSignaturePad } from 'vue-signature-pad';

export function registerPlugins (app) {
  app.use(vuetify)
  app.use(i18n)
  app.component('VueSignaturePad', VueSignaturePad)
}
